import {
  List, ListItem, ListItemButton, ListItemText,
} from '@mui/material';
import { useContext } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import type { InstrumentType } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { useNextStepAfterUpdate } from '../Wizard/Wizard.hooks';
import { stringInstruments, windInstruments } from '../TranscriptionDialog.config';

const useStyles = makeStyles()(() => ({
  container: {
    width: '240px',
    height: '226px',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.23)',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  containerStrings: {
    width: '240px',
    height: '210px',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.23)',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  list: {
    flexGrow: 1,
    overflowY: 'auto', // to make the list scrollable
  },
}));

export interface SpecificInstrumentProps {}

const SpecificInstrument: React.FC<SpecificInstrumentProps> = () => {
  const next = useNextStepAfterUpdate();
  const { classes } = useStyles();
  const { settings } = useContext(TranscriptionDialogContext);
  const { t } = useTranslation();

  const isWind = Object.keys(windInstruments).includes(settings.instruments[0])
    || settings.instruments.includes('wind');
  const specificInstruments = isWind ? windInstruments : stringInstruments;
  const TYPE: InstrumentType = isWind ? 'wind' : 'strings';

  const handleClick = (type: InstrumentType) => {
    next({ instruments: [type] });
  };

  return (
    <div className={TYPE === 'wind' ? classes.container : classes.containerStrings}>
      <List className={TYPE === 'wind' ? classes.list : undefined}>
        {Object.entries(specificInstruments).map(([key, value]) => {
          return (
            <ListItem key={key} disablePadding>
              <ListItemButton
                id={`btn_wizard_specify_${key}`}
                onClick={() => handleClick(key as InstrumentType)}
              >
                <ListItemText primary={t(value)} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default SpecificInstrument;
